import { render, staticRenderFns } from "./ModalRetornoDaAutorizacaoDoHis.vue?vue&type=template&id=a297a894&scoped=true"
import script from "./ModalRetornoDaAutorizacaoDoHis.vue?vue&type=script&lang=ts"
export * from "./ModalRetornoDaAutorizacaoDoHis.vue?vue&type=script&lang=ts"
import style0 from "./ModalRetornoDaAutorizacaoDoHis.vue?vue&type=style&index=0&id=a297a894&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a297a894",
  null
  
)

export default component.exports